import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { create } from '../common/BackendProvider';
import { toast, ToastContainer } from "react-toastify";
import { emptyProfile, InvestmentProfileForm } from "./investmentProfiles/InvestmentProfileForm";

export const InvestmentProfilesCreate = () => {
    const [profile, setProfile] = useState(emptyProfile);
    const [saving, setSaving] = useState(false);
    const navigate = useNavigate();

    const handleCreate = () => {
        setSaving(true);
        create("investment-profiles", { data: profile }).then(() => {
            toast.success("Profile created successfully", {});
            navigate(`/investment_profiles`);
        }).catch((error) => {
            toast.error(error.message, {});
        }).finally(() => {
            setSaving(false);
        });
    };

    return (
        <div className="space-y-5 p-4 lg:p-8">
            <ToastContainer />
            <div>
                <div className="text-xs font-bold uppercase tracking-[0.18em] text-emerald-600">Investor mandate</div>
                <h1 className="mt-2 text-3xl font-bold text-slate-950">Create Investment Profile</h1>
                <p className="mt-2 max-w-3xl text-sm font-medium leading-6 text-slate-500">
                    Build a visual mandate across risk appetite, desired impact intensity, and the SDG areas the investor cares about.
                </p>
            </div>
            <InvestmentProfileForm
                profile={profile}
                onChange={setProfile}
                onSubmit={handleCreate}
                submitLabel="Create profile"
                saving={saving}
            />
        </div>
    );
};
